import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { CreativeExperiences } from './pages/CreativeExperiences';
import { SaaSGrowth } from './pages/SaaSGrowth';
import { DataAnalytics } from './pages/DataAnalytics';
import { ProductEngineering } from './pages/ProductEngineering';
import { Changelog } from './pages/Changelog';
import { Careers } from './pages/Careers';
import { Legal } from './pages/Legal';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
            <Route path="/contact" element={<Contact data-id="element-10" />} data-id="element-9" />
            <Route path="/services/creative-experiences" element={<CreativeExperiences data-id="element-12" />} data-id="element-11" />
            <Route path="/services/saas-growth" element={<SaaSGrowth data-id="element-14" />} data-id="element-13" />
            <Route path="/services/data-analytics" element={<DataAnalytics data-id="element-16" />} data-id="element-15" />
            <Route path="/services/product-engineering" element={<ProductEngineering data-id="element-18" />} data-id="element-17" />
            <Route path="/changelog" element={<Changelog data-id="element-20" />} data-id="element-19" />
            <Route path="/careers" element={<Careers data-id="element-22" />} data-id="element-21" />
            <Route path="/legal" element={<Legal data-id="element-24" />} data-id="element-23" />
            <Route path="/privacy" element={<Privacy data-id="element-26" />} data-id="element-25" />
            <Route path="/terms" element={<Terms data-id="element-28" />} data-id="element-27" />
          </Routes>
        </main>
        <Footer data-id="element-29" />
      </div>
    </BrowserRouter>;
}